//
//
//
//
//
//
//
//
//
//
//
//
//

import { showBModal } from "@Shared/components/bootstrap/BModal";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ActivityConvertButton",
  props: {
    id: {
      type: String,
      required: true
    },
    activityType: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.$nextTick(() => $(this.$refs.tooltipAnchor).tooltip());
  },
  methods: {
    openModal() {
      showBModal("activity-convert-modal", {
        id: this.id,
        activityType: this.activityType
      }, this);
    }
  }
});